import _remove from 'lodash.remove';
import _mapKeys from 'lodash.mapkeys';
import { FETCH_USER, STAR_LIST, UNSTAR_LIST, ADD_ITEM, REMOVE_ITEM } from '../actions/actions_user';

const initialState = {
	userId: '',
	checkedItems: [],
	starredLists: [],
	starredMaximum: false
};

export default function(state = initialState, action) {
	console.log('action', action);

	if (action.error) {
		console.log(action.payload.response);

		// connection problem with database --> don't render
		if (action.payload.response.data === 'DB connection problem') {
			return { ...state, error: true };
		}
		// specifically reacts to an occured error and detects if this error is related to "no user found"
		// in this case the general connection was sucessful but there is no user available for this userId, --> new Use
		else if (action.payload.response.status === 404 && action.payload.response.data === 'No user found') {
			// filles the state's userId property, so a new user is registered on state level.
			return { ...state, userId: action.meta.userId };
		}

		// else if ((action.payload.response.status == 500) && (action.payload.response.data == 'DB connection problem')) {
		// return { ...state, error: true };
		// }

		// else if ((action.payload.response.status == 500) && (action.payload.response.data == 'DB connection problem')) {
		// return { ...state, error: true };
		// }
	}

	let newState = Object.assign({}, state);

	switch (action.type) {
		case FETCH_USER:
			// create new state and rename the properties
			return {
				...state,
				userId: action.payload.data && action.payload.data[0]['user_id'],
				checkedItems: action.payload.data && _mapKeys(action.payload.data[0]['checked_items'], 'list_id'),
				starredLists: action.payload.data && action.payload.data[0]['starred_lists']
			};

		case STAR_LIST:
			// check if user reached the maximum of 6 starred lists
			// but because this check happens before the state is mutated, the check happens on "5"
			if (state.starredLists.length === 5) {
				newState.starredMaximum = true;
				newState.starredLists.push(action.meta.id);
			} else {
				newState.starredLists.push(action.meta.id);
			}

			return newState;

		case UNSTAR_LIST:
			// mutate state
			_remove(newState.starredLists, item => {
				return item === action.meta.id;
			});
			// set this to false, because in any scenario the counter will be below the maximum
			newState.starredMaximum = false;
			return newState;

		case ADD_ITEM:
			// find current list in whole collection of all lists
			let currentList = newState.checkedItems[action.meta.listId];
			// if no list found, create a new one
			if (typeof currentList === 'undefined') {
				let newList = {
					list_id: action.meta.listId,
					items: [action.meta.itemId]
				};
				newState.checkedItems[action.meta.listId] = newList;
			} else {
				// else just push to items array
				newState.checkedItems[action.meta.listId].items.push(action.meta.itemId);
			}

			return newState;

		case REMOVE_ITEM:
			// remove item from state
			_remove(newState.checkedItems[action.meta.listId].items, item => {
				return item === action.meta.itemId;
			});
			return newState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_user.js